import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MasterServiceService } from 'src/app/shared/services/master-service.service';
import { SsoLoginService } from '../sso-login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EncrypterService } from 'src/app/shared/services/encrypter.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { AppInitializerService } from 'src/app/shared/services/app-intializer.service';
import { customJwtDecode as decode } from 'src/app/shared/helpers/custom-jwt';

@Component({
    selector: 'app-employee-sso-detail',
    templateUrl: './employee-sso-detail.component.html',
    styleUrls: ['./employee-sso-detail.component.css'],
    standalone: false
})
export class EmployeeSsoDetailComponent {

  accountid: any;
  employeessoid: any;
  empData: any;

  constructor(
    private _masterService: MasterServiceService,
    private toastr: ToastrService,
    private _ssoLoginService: SsoLoginService,
    private route: ActivatedRoute,
    private _sessionService: SessionService,
    private _encrypterService: EncrypterService,
    private router: Router,
    private _appInitializerService: AppInitializerService
  ) {

  }
  ngOnInit() {
    const paramsCount = Object.keys(this.route.snapshot.params).length;
    this.accountid = this.route.snapshot.paramMap.get('accountid')!;
    this.employeessoid = this.route.snapshot.paramMap.get('employeessoid')!;
    this.empData = this.route.snapshot.paramMap.get('empData')!;

    this.employeeSSOLogin();
  }

  employeeSSOLogin() {
    this._ssoLoginService.employeeSSOLogin({
      'customerAccountId': this.accountid.toString(),
      'urlSegment': this.employeessoid.toString(),
    }).subscribe({
      next: (resData: any) => {
        if (resData.statusCode) {
          localStorage.setItem('activeUser', JSON.stringify(resData));
          let token: any = decode(resData.token);

          localStorage.setItem('product_type', token.product_type);
          localStorage.setItem('show_bus_setting_page', token.show_bus_setting_page);
          let isEmployer_flag = token.isEmployer;
          let empcode_mob =
            !localStorage.getItem('empcode_mob') ? [] : this._encrypterService.aesDecrypt(localStorage.getItem('empcode_mob'));

          const promises: Promise<any>[] = [];

          if (empcode_mob.length == 0 && isEmployer_flag == '0') {
            //promises.push(this.getEmpCodeFromMobileNumber(token));
          }

          if (localStorage.getItem('activeUser')) {
            //promises.push(this.get_url_access_right_global(token));
            // console.log('this.get_url_access_right_global(token)');
            //promises.push(this.getKRaSettings(token));
          }

          // Wait for both promises to resolve
          Promise.all(promises)
            .then(() => {
              localStorage.setItem('employeeSSO', 'true');
              // console.log('Both tasks completed successfully.');
              this._appInitializerService.setSession();
              //this.router.navigate(['/profile/investments?type=mobile']);


              const urlTree = this.router.createUrlTree(['/profile/employee-detail'], {
                queryParams: { data: this.empData }
              });
              const url = urlTree.toString();
              window.open(url, '_self');


              // this.router.navigate(['/profile/investments'], { queryParams: { type: 'mobile' } });
            })
            .catch((error) => {
              console.error('Error in one of the tasks:', error);
              //this.handleInvalidSession();
            });
        } else {
          this.toastr.error(resData.message, 'Oops!');
        }
      }, error: (e) => {
        // console.log(e);
      }
    })
  }


}
